import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ActionStatus } from '@pixacare/shared';
import { SyncActionStateProgress } from '@shared/models/sync/sync-action-state-progress';
import { TuiIcon } from '@taiga-ui/core';
import { Size } from '../../../../shared/models/enums/size.enum';
import { SyncProgressChipComponent } from '../sync-progress-chip/sync-progress-chip.component';
import { computeSyncPercentage } from '../utils/compute-sync-percentage';

type SyncGlobalStatusIconVariant = 'iconOnly' | 'detailed';

const ICON_FONT_SIZE: Record<Size, string> = {
  [Size.TINY]: '0.75rem',
  [Size.SMALL]: '1rem',
  [Size.MEDIUM]: '1.5rem',
  [Size.LARGE]: '2rem',
  [Size.FULLSCREEN]: '3rem',
};

@Component({
  selector: 'pxc-sync-global-status-icon',
  templateUrl: './sync-global-status-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TuiIcon, SyncProgressChipComponent],
  host: {
    class: 'inline-flex items-center justify-center align-middle',
  },
})
export class SyncGlobalStatusIconComponent {
  readonly status = input<ActionStatus>(ActionStatus.IN_PROGRESS);
  readonly variant = input<SyncGlobalStatusIconVariant>('iconOnly');
  readonly size = input<Size>(Size.MEDIUM);
  readonly progress = input<SyncActionStateProgress>({ done: 0, total: 0 });
  protected readonly ActionStatus = ActionStatus;
  protected readonly Size = Size;

  protected readonly iconFontSize = computed(() => ICON_FONT_SIZE[this.size()]);

  protected readonly percentage = computed(() => computeSyncPercentage(this.progress()));
}
